import React from 'react'
import styled from 'styled-components'

const InstructionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 24px 0 0 0;
  padding: 0;
`

const InstructionText = styled.p`
  font-size: 16px;
  color: #1f2124;
  margin: 0;
`

const DeadlineText = styled.p`
  font-size: 16px;
  color: #1f2124;
  margin: 0;

  strong {
    font-weight: 600;
  }
`

const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
`

interface InstructionsTextProps {
  date: string
}

const InstructionsText: React.FC<InstructionsTextProps> = ({ date }) => {
  return (
    <InstructionsContainer>
      <InstructionText>
        A continuación encontrarás diferentes competencias a evaluar, cada una de estas tendrá ítems o comportamientos
        asociados. Usando la escala de 1 a 4, donde 1 es bajo rendimiento y 4 es alto rendimiento, asigna a cada uno de
        los evaluados el puntaje que represente su desempeño en cada comportamiento.
      </InstructionText>

      <InstructionText>
        En caso de requerirlo, podrás guardar el progreso de tus respuestas y retomar la prueba en otro momento.
      </InstructionText>

      <DeadlineText>
        Recuerda que la fecha límite para responder la evaluación es el <strong>{date}</strong>.
      </DeadlineText>

      <SectionTitle>Competencias a evaluar:</SectionTitle>
    </InstructionsContainer>
  )
}

export default InstructionsText
